import { css } from 'lit';

export const styles = css `
  :host(.selected) {
    background-color: var(--u-select-option-selected-bg-color, color-mix(in srgb, var(--u-color-primary, rgb(103, 80, 164)) 12%, transparent));
  }
  :host(.selected) .icon,
  :host(.selected) .content {
    color: var(--u-select-option-selected-text-color, var(--u-color-primary, rgb(103, 80, 164)));
  }

  :host(:not(.selected):not([has-trailing-icon])) .trailing {
    display: none;
  }
`;
